let arr=[
    {name:'种植',value:'种植'},
    {name:'畜牧',value:'畜牧'},
    {name:'水产',value:'水产'}
]
export default arr